export default __webpack_public_path__ + "static/media/Confirmed.f14973b9.svg";